import React from "react";
import { InputGroup, InputLeftElement, Input } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";

const ResumeSearchBar = ({ value, onChange, placeholder = "Search resumes" }) => {
  return (
    <InputGroup>
      <InputLeftElement pointerEvents="none">
        <FiSearch />
      </InputLeftElement>
      <Input value={value} onChange={onChange} placeholder={placeholder} />
    </InputGroup>
  );
};

export default ResumeSearchBar;
